// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"610":"d49bdece1e2623db4be3","943":"bc724168f90d3b405734"}[chunkId] + ".bundle.js";
};